import { defineStore } from 'pinia';
import { ref, type Ref } from 'vue';

import type { MyWallet } from '@/helpers/interfaces/wallet.interface';
import { pinia } from '@/pinia';
import { axiosI } from '@/plugins';
import { ApiHandler } from '@/submodules/postman-to-ts/apiHandler';

import { useOrganizationStore } from './organzation.pinia';

export const useWalletStore = defineStore('WalletStore', () => {
  const myWallet: Ref<MyWallet | null> = ref(null);
  const orgStore = useOrganizationStore(pinia);
  const getMyWallet = async () => {
    try {
      if (!orgStore.walletEnabled) return;
      const { path, method } = ApiHandler.auth.getMyWallet;
      const { data } = await axiosI<MyWallet>(path(), {
        method,
      });
      myWallet.value = data;
    } catch (error) {
      console.log(error);
    }
  };

  return {
    myWallet,
    getMyWallet,
  };
});
